module.exports = __webpack_public_path__ + "img/female_resultE.277663d1.png";